import * as React from 'react';
import { AutoField } from './AutoField';
export function ComponentField(_a) {
    var store = _a.store, name = _a.name;
    // TODO: custom field specs
    return React.createElement(AutoField, { store: store, name: name });
}
//# sourceMappingURL=ComponentField.js.map